const KAKAO_SCRIPT_ID = 'kakao-map-sdk';

let loadPromise: Promise<void> | null = null;

export const getKakaoMapAppKey = () => import.meta.env.VITE_APP_KAKAOMAP_KEY?.trim() ?? '';

export const loadKakaoMapScript = (appKey: string): Promise<void> => {
	if (!appKey) {
		return Promise.reject(new Error('Kakao map app key is not configured'));
	}

	if (typeof window !== 'undefined' && window.kakao?.maps) {
		return Promise.resolve();
	}

	if (loadPromise) {
		return loadPromise;
	}

	loadPromise = new Promise((resolve, reject) => {
		const existing = document.getElementById(KAKAO_SCRIPT_ID) as HTMLScriptElement | null;
		if (existing) {
			if (window.kakao?.maps) {
				window.kakao.maps.load(() => resolve());
				return;
			}
			existing.addEventListener('load', () => window.kakao?.maps.load(() => resolve()));
			existing.addEventListener('error', () => reject(new Error('Failed to load Kakao map SDK')));
			return;
		}

		const script = document.createElement('script');
		script.id = KAKAO_SCRIPT_ID;
		script.async = true;
		script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${appKey}&libraries=services,clusterer&autoload=false`;
		script.onload = () => {
			window.kakao.maps.load(() => resolve());
		};
		script.onerror = () => reject(new Error('Failed to load Kakao map SDK'));
		document.head.appendChild(script);
	});

	return loadPromise;
};
